import { render, staticRenderFns } from "./daily-winner-mb.vue?vue&type=template&id=2ef65b30&"
import script from "./daily-winner-mb.vue?vue&type=script&lang=js&"
export * from "./daily-winner-mb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports